module.exports = __webpack_public_path__ + "static/media/2.Chain pully.d4633105.png";